import React, { useEffect, useState } from "react";
import "./investor-management.css";
import OverviewCard from "../../components/OverView-Card/overview-card";
import RegistrationTable from "../../components/Registration-table/registration-table";
import PopularBond from "../../components/Popular-bond/Popular-bond";
import RegistartionDetail from "../../components/Registration-details/Registartion-detail";
import RegistartionTableWealth from "../../components/Registration-table-wealth";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
import SelectButtonV2 from "../../components/SelectButtonV2";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
function InvestorManagementMainPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Investor");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectNumber, setSelectedNumber] = useState("10");
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  const [investorDetails, setInvestorDetails] = useState([]);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("investorManagementPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  console.log("userPermissionData", userPermissionData);

  const [error, setError] = useState(null);

  const optionsOccupation = [
    "All",
    "Pending",
    // "Under Review",
    "Approve",
    // "Query Raised",
    // "Update Request",
  ];
  const transformStatus = (status) => {
    switch (status) {
      case "All":
        return "";
      case "Pending":
        return "pending";
      case "Under Review":
        return "under_review";
      case "Approve":
        return "approve";
      case "Query Raised":
        return "query";
      case "Update Request":
        return "update_request";
      default:
        return "";
    }
  };

  const optionsShow = ["All", "10", "20", "50"];
  const buttonData = [
    {
      label: "Investor",
      path: "/investment-management/investor", // Path for the Investor button
    },
    {
      label: "Wealth Partner",
      path: "/investment-management/wealth-partner", // Path for the Wealth Partner button
    },
  ];

  const columnHelper = createColumnHelper();

  const handleClick = (path, label) => {
    setActiveTab(label);
    navigate(path); // Navigate to the given path
  };

  const handleSelectOccupation = (value) => {
    setSelectedOccupation(value);
    setPage(1);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
    setPage(1);
    setPazeSize(value === "All" ? total : parseInt(value));
  };

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investments/investor`;
    const kyc = transformStatus(selectedOccupation);
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
          userType: "investor",
          status: kyc || undefined,
          perPage: selectNumber === "All" ? total : parseInt(selectNumber),
        },
      });
      setInvestorDetails(response?.data?.data?.users);
      setPage(response?.data?.data?.pagination?.currentPage);
      setTotal(response?.data?.data?.pagination?.totalRecords);
      setPazeSize(response?.data?.data?.pagination?.perPage); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, [page, selectedOccupation, searchInputApi, selectNumber]);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === "") {
      setSearchInputApi("");
    }
  }, [searchInput]);

  function formatStatus(input) {
    if (!input) return ""; // Handle empty or undefined input
    return input.replace(/_/g, " ").replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }

  const columns = [
    columnHelper.accessor("name", {
      cell: (info) => info.renderValue(),
      header: () => <span>Investor Name</span>,
    }),

    columnHelper.accessor("uccCode", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="">
          <span>UCC Code</span>
        </div>
      ),
    }),

    columnHelper.accessor("uccCode", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="">
          <span>Bond Id</span>
        </div>
      ),
    }),
    columnHelper.accessor("investedDate", {
      cell: (info) => {
        let createdAt = info?.getValue();
        // Check if the date value exists before formatting
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Invested Date</span>,
    }),
    columnHelper.accessor("status", {
      // cell: (info) => (info.renderValue() ? info.renderValue() : "N/A"),
      cell: (info) => {
        const kycStatus = info?.row?.original?.status;
        return (
          <div
            className={` ${
              kycStatus === "approve"
                ? "text-[#31A653]"
                : kycStatus === "under_review"
                ? "text-[#FF7900]"
                : kycStatus === "query" || kycStatus === "rejected"
                ? "text-[#E91518]"
                : kycStatus === "update_request"
                ? "text-[#3B68DD]"
                : "text-[#FFB400]"
            }`}
          >
            {formatStatus(kycStatus)}
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    columnHelper.accessor("totalInvestedAmount", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => <span>Total invested Amount</span>,
    }),
    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        console.log("investorid", uniqueId);
        const NavigateScheme = (uniqueId) => {
          navigate("/investment-management/investor/details", {
            state: {
              uniqueId: uniqueId,
            },
          });
        };
        return (
          <div
            className="flex flex-start "
            onClick={() => NavigateScheme(uniqueId)}
          >
            <img src={eye} alt="Eye " className="cursor-pointer" />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const handleSearchInput = (value) => {
    setSearchInput(value);
  };
  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  const downloadInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investments/investor/export-to-excel`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        params: {
          search: searchInput, // Pass `searchInput` as a query parameter
        },
        responseType: "blob",
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "investor_details.xlsx"; // Provide a default file name

      // Append the link to the document and trigger the click
      document.body.appendChild(link);
      link.click();

      // Clean up the link and blob URL
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      console.log("File downloaded successfully!");
      console.log(response, "response-download");
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const onDownloadClick = () => {
    downloadInvestorDetails();
  };

  return (
    <div className="mt-20 md:px-4">
      {buttonData.map((button, index) => (
        <button
          key={index}
          className={`w-[135px] text-[14px] md:px-4 py-2   ${
            activeTab === button.label ? "bg-[#035C98] text-white " : ""
          } ${
            index === 0 ? "rounded-l" : "rounded-r"
          } focus:outline-none focus:ring-2`}
          onClick={() => handleClick(button.path, button.label)} // Navigate on click
        >
          {button.label}
        </button>
      ))}
      <div className="bg-white md:px-8 px-4 md:py-4 py-2 md:mt-10 mt-4 rounded-[10px] overflow-auto">
        <h1 className="text-[#252C32] text-[24px]">Investor </h1>
        <div class="">
          <div class="flex flex-wrap justify-between  items-center gap-x-2 md:pb-9 pb-6 pt-5 gap-y-4">
            <div className="flex flex-wrap gap-x-8 gap-y-4">
              <div className="flex gap-0.5 flex-grow">
                <input
                  type="text"
                  placeholder="Search by Unique ID/name"
                  value={searchInput}
                  onChange={(e) => handleSearchInput(e?.target?.value)}
                  className="px-3 py-2 border border-gray-300 rounded-tl-[10px] rounded-bl-[10px] md:w-[300px] w-full"
                />
                <button
                  onClick={handleSearchClick}
                  className="bg-[#0066b2] text-white border-none px-4 py-2 rounded-tr-[10px] rounded-br-[10px] cursor-pointer"
                >
                  Search
                </button>
              </div>
              <div class="flex items-center">
                <div className="flex items-center min-w-[136px]">
                  <SelectButtonV2
                    options={optionsOccupation}
                    selectedValue={selectedOccupation}
                    onSelect={handleSelectOccupation}
                    placeholder="Status"
                  />
                </div>
              </div>
            </div>
            {userPermissionData?.investment?.download && (
              <div
                onClick={onDownloadClick}
                class="flex items-center bg-[#035C98] px-4 rounded-[8px] cursor-pointer"
              >
                <button class="btn   text-white font-bold  ">Download</button>
                <img src={download} alt="download" />
              </div>
            )}
          </div>

          <div className="flex items-center w-[154px]">
            <p className="pr-1">Show</p>
            <SelectButton
              options={optionsShow}
              selectedValue={selectNumber}
              onSelect={handleSelectNumber}
            />
            <p className="pl-3">Entries</p>
          </div>
        </div>
      </div>
      <div className="w-full font-poppins mt-3 pt-4 px-4 bg-white rounded-[10px] border">
        <ReactTable
          key={JSON?.stringify(investorDetails)}
          defaultData={investorDetails}
          columns={columns}
        />
      </div>

      {investorDetails?.length > 0 && (
        <div className="w-auto bg-white">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={pageSize}
            maxPageNumbersToShow={5}
            storageKey="investorManagementPage"
          />
        </div>
      )}
    </div>
  );
}

export default InvestorManagementMainPage;
